// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setAddToListModalIsOpen from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import addToWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import ImprovePageLinkModal from "@steiner/App/Components/ImprovePageLink/ImprovePageLinkModal";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    extendedStyles?: ImprovePageLinkStyles;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    wishListSettings: getSettingsCollection(state).wishListSettings,
});

const mapDispatchToProps = {
    setAddToListModalIsOpen,
    addToWishList,
};

export interface ImprovePageLinkStyles {
    Improvelink?: LinkPresentationProps;
    improvePageModal?: ModalPresentationProps;
}

export const improvePageLinkStyles: ImprovePageLinkStyles = {};

const ImprovePageLink: React.FC<Props> = ({ extendedStyles, ...otherProps }) => {
    const toasterContext = React.useContext(ToasterContext);
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [styles] = React.useState(() => mergeToNew(improvePageLinkStyles, extendedStyles));

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };
    const modalOpenHandler = () => {
        setModalIsOpen(true);
    };
    return (
        <>
            <Link {...styles.Improvelink} onClick={modalOpenHandler} {...otherProps}>
                {translate("How Can We Improve This Page?")}
            </Link>
            <Modal
                {...styles.improvePageModal}
                headline={translate("How can we make this page better?")}
                isOpen={modalIsOpen}
                handleClose={modalCloseHandler}
            >
                <ImprovePageLinkModal closeModal={modalCloseHandler} />
            </Modal>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ImprovePageLink);
